import { cn } from '../lib/utils'

// "I'm here" — a double check in going green: one step past the single going
// check, so a confirmed presence reads as the stronger signal next to a plan.
// Drawn on lucide's 24-unit grid (circle r=10) so the white ring is an SVG
// stroke that scales with the icon exactly like `CheckCircle2`'s does — a CSS
// border stays a fixed width and read thinner beside it. `strokeWidth` matches
// whatever the neighbouring going check uses (2 by default, 3 in facepiles).
export function CheckInIcon({ className, strokeWidth = 2 }: { className?: string; strokeWidth?: number }) {
  // The double check is scaled down to fit inside the ring; its stroke is scaled
  // back up so it renders at the same weight as the ring.
  const scale = 0.55
  return (
    <svg viewBox="0 0 24 24" aria-hidden className={cn('shrink-0', className)}>
      <circle cx="12" cy="12" r="10" className="fill-going stroke-going-foreground" strokeWidth={strokeWidth} />
      <g
        transform={`translate(12 12) scale(${scale}) translate(-12 -11.75)`}
        fill="none"
        className="stroke-going-foreground"
        strokeWidth={strokeWidth / scale}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M18 6 7 17l-5-5" />
        <path d="m22 10-7.5 7.5L13 16" />
      </g>
    </svg>
  )
}
